import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[numeric]',
    standalone: false
})
export class NumericDirective {


  constructor(private _el: ElementRef, private readonly ngControl: NgControl) { }

  
  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value.replace(/\./g,'').replace(/\,/g,'.') ;
    //this._el.nativeElement.value = initalValue;
    this.ngControl.control.setValue(Number.parseFloat(initalValue),{ 
      emitEvent: false,
      emitModelToViewChange: false,
      emitViewToModelChange: false})
    if ( initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
      
  }

}